import { t } from '@/i18n/utils'

export const loginCommonConfig = {
  texts: {
    get title() { return t('LoginPageTitle') },
    get emailDescription() { return t('EmailLoginDescription') },
    get signInWithFacebook() { return t('Facebook') },
    get signInWithGoogle() { return t('Google') },
    get signInWithApple() { return t('Apple') },
    get continueWithEmail() { return t('ContinueWithEmail') },
    get signInWithEmail() { return t('EmailPageTitle') },
    get yourEmail() { return t('EmailAddress') },
    get verificationCode() { return t('VerificationCode') },
    get getVerificationCode() { return t('SendCode') },
    get signIn() { return t('Continue') },
    get userAgreement() { return t('UserAgreement2') },
    get userAgreementLink() { return t('userAgreementLink') },
    get and() { return t('and') },
    get privacyPolicyLink() { return t('PrivacyPolicy') },
    get logout() { return t('logout') },
    get loading() { return t('loading') },
  },
}
